module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs bold"
  }, [_c('ul', {
    staticClass: "d-flex justify-content-between px-4"
  }, _vm._l((_vm.newTabs), function(tab) {
    return _c('li', {
      class: {
        'active': tab.active
      },
      domProps: {
        "innerHTML": _vm._s(_vm.addBadgeToLabel(tab))
      },
      on: {
        "click": function($event) {
          return _vm.activateTab(tab)
        }
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "box shadowless"
  }, [_c('event-details', {
    attrs: {
      "active": _vm.newTabs[0].active,
      "event": _vm.event
    }
  }), _vm._v(" "), _c('event-extras', {
    attrs: {
      "active": _vm.newTabs[1].active,
      "event": _vm.event
    }
  }), _vm._v(" "), _c('event-notes', {
    attrs: {
      "active": _vm.newTabs[2].active,
      "event": _vm.event
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-471a439d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-471a439d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/EventTabs.vue
// module id = 2719
// module chunks = 0